"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateSchedule = exports.serializeSchedule = void 0;
const serializeSchedule = (item) => {
    const schedule = typeof item.data.schedule === "string" ? item.data.schedule : "";
    const timezone = typeof item.data.timezone === "string" ? item.data.timezone : "";
    return [schedule, timezone].join(", ");
};
exports.serializeSchedule = serializeSchedule;
const validateSchedule = (item) => {
    if (!item.required || (item.data.schedule && item.data.timezone)) {
        return { valid: true };
    }
    return {
        valid: false,
        error: { message: "Please enter a valid schedule and timezone" },
    };
};
exports.validateSchedule = validateSchedule;
//# sourceMappingURL=schedule.js.map